import React from 'react';
import GradientTextItem from '../../../molecules/shared/gradientTextItem/GradientTextItem';
import { addLineBreak } from '../../../../utils/utils';

const CounterSection = ({ section }) => (
  <div className="flex w-full flex-col flex-1 px-8 lg:mx-auto max-w-5xl my-24">
    <div className="flex flex-1 items-center justify-center">
      <div className="flex min-w-fit flex-col md:flex-row w-full min-h-60 h-auto bg-white shadow-xl rounded-[40px] py-6 px-6 lg:px-10 justify-between items-top gap-8">
        {section.componentData.map((item) => (
          <GradientTextItem
            key={item.number}
            text={item.number}
            description={addLineBreak(item.text)}
            subDescription={item.subText && addLineBreak(item.subText)}
          />
        ))}
      </div>
    </div>
  </div>
);

export default CounterSection;
